import React from "react";

const Shippingndrefund = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 md:px-20 text-gray-800">
      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <h1 className="text-3xl font-bold text-center text-indigo-700 mb-6">
          Shipping & Refund Policy
        </h1>
        <p className="text-center text-sm text-gray-500 mb-10">
          <span className="italic">Last Updated: 2025</span>
        </p>

        {/* 1. Our Policy */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            1. Our Policy
          </h2>
          <p className="leading-relaxed">
            Due to the hygienic nature of our oral care products, we generally
            do not accept returns or offer refunds for simply changing your
            mind. However, your satisfaction is our priority, and we strive to
            resolve any genuine concerns promptly.
          </p>
        </section>

        {/* 2. Eligibility for Return/Refund */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            2. Eligibility for Return/Refund
          </h2>
          <p className="leading-relaxed mb-2">
            We accept returns and offer a full refund or free replacement only
            if the product you received is:
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Damaged during transit.</li>
            <li>Defective (e.g., faulty seal, incorrect product).</li>
            <li>Expired or near its expiration date.</li>
          </ul>
        </section>

        {/* 3. How to Initiate a Return */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            3. How to Initiate a Return
          </h2>
          <ol className="list-decimal list-inside space-y-2">
            <li>
              Contact our customer care team at{" "}
              <a
                href="mailto:support@sridanth.com"
                className="text-indigo-600 underline"
              >
                support@sridanth.com
              </a>{" "}
              within 48 hours of receiving your order.
            </li>
            <li>
              Provide your order number and a clear description (and preferably
              photos or a video) of the issue.
            </li>
          </ol>
        </section>

        {/* 4. The Process */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            4. The Process
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Once we receive and approve your return request, we will provide
              instructions for returning the item (if necessary) and process a
              replacement or refund to your original payment method.
            </li>
            <li>
              <strong>Recommendation:</strong> For a smooth resolution, we
              highly recommend making a short video or taking photos while
              unboxing your order. This helps us quickly address any issues
              related to shipping damage or missing items.
            </li>
          </ul>
        </section>

        {/* 5. Shipping */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            5. Shipping
          </h2>
          <p className="leading-relaxed">
            We will provide a prepaid return shipping label if the return is due
            to our error (e.g., we sent the wrong product). For other eligible
            returns, we will guide you through the return process and provide
            instructions accordingly.
          </p>
        </section>

        {/* 6. Contact Us */}
        <section>
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            6. Contact Us
          </h2>
          <p className="leading-relaxed">
            For any questions about returns or refunds, please contact us at:{" "}
            <a
              href="mailto:support@sridanth.com"
              className="text-indigo-600 underline"
            >
              support@sridanth.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Shippingndrefund;
